@if (!!employee) {
  <!-- Define our user menu context. -->
  <span>{{ employee.firstName }} {{ employee.lastName }} &lpar;{{ employee.employeeId }}&rpar;</span>

  <!--
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>person_pin</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item routerLink="/sign-out">
      <span>Logout</span>
    </button>
  </mat-menu>
-->
}
